<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <h3>Comporbacion Back</h3>
            <p> {{ respuestaback }} </p>
            <h3>Comporbacion BackBD</h3>
            <p> {{ respuestabackBD }} </p>
        </div>
    </div>
</div>